import { MiniTicketCard } from "../../mobile/components/cards";
import React, { useGlobal } from "reactn";
import { pathOr } from "lib/functions";
import { useGetLines } from "hooks/useGetLines";
import { useEffect } from "react";

/*
 * La respuesta de ticket:created no tiene la misma forma que la
 * respuesta de la api de usuario (userio). Por esto, existen distintas
 * formas de conseguir la oficina y la fila del ticket.
 *
 * ticket:created usa el slug de la línea para conseguirla del estado
 * la API de usuario usa ticket.line_name
 *
 * TODO: crear un adaptador para que ticket:created y userio tengan las misma
 * forma y no tener que hacer checks
 */
export const TicketCard = ({ ticket }) => {
	const [global] = useGlobal();
	const { officesv2, offices } = global;
	const slug = ticket.officeSlug || ticket.office;
	const office = officesv2.bySlug[slug] || offices[slug];
	const [lines] = useGlobal("linesv2");
	const line =
		lines.bySlug[ticket.lineSlug] && lines.bySlug[ticket.lineSlug].name;

	return (
		<>
			<MiniTicketCard
				office={office}
				line={line || ticket.line_name || ticket.lineName}
				ticket={ticket}
				clickable={true}
			/>
		</>
	);
};
